import React from 'react';
import {
  Text,
  Box,
  Button,
} from '@chakra-ui/react';
import { motion } from 'framer-motion';
import { VStack } from '@chakra-ui/react';


interface WinnerModalProps {
  winnerName: string;
  onRestart: () => void;
}

const Confetti: React.FC = () => {
  const confettiArray = Array.from({ length: 60 });
  return (
    <Box position="absolute" top={0} left={0} w="100vw" h="100vh" pointerEvents="none" zIndex={2}>
      {confettiArray.map((_, i) => (
        <motion.div
          key={i}
          style={{
            position: 'absolute',
            left: `${Math.random() * 100}%`,
            top: '-40px',
            width: 12,
            height: 12,
            borderRadius: '50%',
            background: `hsl(${Math.random() * 360}, 80%, 60%)`,
          }}
          animate={{
            y: [0, 800],
            rotate: [0, 360],
          }}
          transition={{
            duration: 2.5 + Math.random(),
            delay: Math.random(),
            repeat: Infinity,
          }}
        />
      ))}
    </Box>
  );
};


const WinnerModal: React.FC<WinnerModalProps> = ({ winnerName, onRestart }) => {
  return (
    <Box
      position="fixed"
      top={0}
      left={0}
      w="100vw"
      h="100vh"
      zIndex={2000}
      bgGradient="linear(to-br, teal.50, blue.100)"
      display="flex"
      flexDirection="column"
      justifyContent="center"
      alignItems="center"
      overflow="hidden"
    >
      <Confetti />
      <Box
        borderRadius={0}
        m={0}
        h="100vh"
        w="100vw"
        position="relative"
        display="flex"
        flexDirection="column"
        justifyContent="center"
        alignItems="center"
        overflow="hidden"
      >
        <Text
          textAlign="center"
          fontSize="10xl"
          fontWeight="extrabold"
          bgClip="text"
          letterSpacing={2}
          py={6}
          mb={2}
        >
          🎉 Winner! 🎉
        </Text>
        <Box display="flex" flexDirection="column" alignItems="center">
          <Text fontSize="3xl" fontWeight="bold" color="teal.700" mb={8}>
            {winnerName} reached 10000!
          </Text>
          <Button
            colorScheme="teal"
            size="xl"
            px={12}
            py={6}
            fontSize="2xl"
            fontWeight="bold"
            boxShadow="2xl"
            transition="all 0.2s"
            onClick={onRestart}
          >
            Play Again
          </Button>
        </Box>
      </Box>
    </Box>
  );
};

export default WinnerModal;
